import type { ComponentType } from 'react'

import { BeneficioAcumuladoArticle } from '@/features/aprender/BeneficioAcumuladoArticle'
import { BeneficioRealArticle } from '@/features/aprender/BeneficioRealArticle'
import { CartaRentableArticle } from '@/features/aprender/CartaRentableArticle'
import { ComoHacerInventarioHosteleriaArticle } from '@/features/aprender/ComoHacerInventarioHosteleriaArticle'
import { ComoSaberSiMiRestauranteEsRentableArticle } from '@/features/aprender/ComoSaberSiMiRestauranteEsRentableArticle'
import { ControlAlbaranesArticle } from '@/features/aprender/ControlAlbaranesArticle'
import { ControlarNumerosArticle } from '@/features/aprender/ControlarNumerosArticle'
import { CostePorPlatoArticle } from '@/features/aprender/CostePorPlatoArticle'
import { CosteTeoricoRealArticle } from '@/features/aprender/CosteTeoricoRealArticle'
import { DeIdeaANegocioPaso1ViabilidadArticle } from '@/features/aprender/DeIdeaANegocioPaso1ViabilidadArticle'
import { EscandalloMenuDelDiaArticle } from '@/features/aprender/EscandalloMenuDelDiaArticle'
import { EscandalloPasoAPasoArticle } from '@/features/aprender/EscandalloPasoAPasoArticle'
import { FoodCostEspanaArticle } from '@/features/aprender/FoodCostEspanaArticle'
import { FoodCostMargenArticle } from '@/features/aprender/FoodCostMargenArticle'
import { InventarioTeoricoRealNoCuadraArticle } from '@/features/aprender/InventarioTeoricoRealNoCuadraArticle'
import { MenuNavidadGruposEscandalloArticle } from '@/features/aprender/MenuNavidadGruposEscandalloArticle'
import { MermasHosteleriaPruebaPapeleraArticle } from '@/features/aprender/MermasHosteleriaPruebaPapeleraArticle'
import { PlanViabilidadHosteleriaPrimerosPasosArticle } from '@/features/aprender/PlanViabilidadHosteleriaPrimerosPasosArticle'
import { QueEsElFoodCostArticle } from '@/features/aprender/QueEsElFoodCostArticle'
import { QueEsElPrimeCostArticle } from '@/features/aprender/QueEsElPrimeCostArticle'
import { QueEsUnEscandalloArticle } from '@/features/aprender/QueEsUnEscandalloArticle'
import { RevisarNumerosArticle } from '@/features/aprender/RevisarNumerosArticle'
import {
    LEARN_ARTICLES,
    type LearnArticleBodyProps,
    type LearnArticleDefinition,
    localizeLearnArticle,
} from '@/features/aprender/articles'
import type { LandingLocale } from '@/navigation/localeConstants'

const LEARN_ARTICLE_BODIES: Record<string, ComponentType<LearnArticleBodyProps>> = {
    'menu-navidad-grupos-escandallo': MenuNavidadGruposEscandalloArticle,
    'inventario-teorico-real-no-cuadra': InventarioTeoricoRealNoCuadraArticle,
    'mermas-hosteleria-prueba-papelera': MermasHosteleriaPruebaPapeleraArticle,
    'como-hacer-inventario-hosteleria': ComoHacerInventarioHosteleriaArticle,
    'como-saber-si-mi-restaurante-es-rentable': ComoSaberSiMiRestauranteEsRentableArticle,
    'beneficio-acumulado-cuanto-sacar-restaurante': BeneficioAcumuladoArticle,
    'plan-viabilidad-hosteleria-primeros-pasos': PlanViabilidadHosteleriaPrimerosPasosArticle,
    'beneficio-real-restaurante-cuanto-puedo-sacar': BeneficioRealArticle,
    'de-idea-a-negocio-paso-1-viabilidad': DeIdeaANegocioPaso1ViabilidadArticle,
    'escandallo-menu-del-dia': EscandalloMenuDelDiaArticle,
    'controlar-numeros-restaurante-no-delegar': ControlarNumerosArticle,
    'cada-cuanto-revisar-numeros-restaurante': RevisarNumerosArticle,
    'control-albaranes-hosteleria': ControlAlbaranesArticle,
    'que-es-el-prime-cost': QueEsElPrimeCostArticle,
    'que-es-el-food-cost': QueEsElFoodCostArticle,
    'que-food-cost-deberia-tener-restaurante-espana': FoodCostEspanaArticle,
    'como-calcular-coste-de-un-plato': CostePorPlatoArticle,
    'que-es-un-escandallo': QueEsUnEscandalloArticle,
    'como-hacer-un-escandallo-paso-a-paso': EscandalloPasoAPasoArticle,
    'food-cost-y-margen-bruto-restaurante': FoodCostMargenArticle,
    'coste-teorico-vs-coste-real-cocina': CosteTeoricoRealArticle,
    'disenar-carta-rentable-restaurante': CartaRentableArticle,
}

export function listRoutableLearnArticles(locale: LandingLocale = 'es') {
    return LEARN_ARTICLES.filter(article => LEARN_ARTICLE_BODIES[article.id])
        .map(article => localizeLearnArticle(article, locale))
        .sort((a, b) => b.publishedAt.localeCompare(a.publishedAt))
}

export function listRoutableLearnArticleDefinitions(): LearnArticleDefinition[] {
    return LEARN_ARTICLES.filter(article => LEARN_ARTICLE_BODIES[article.id]).sort((a, b) =>
        b.publishedAt.localeCompare(a.publishedAt),
    )
}

export function getLearnArticleBody(id: string) {
    return LEARN_ARTICLE_BODIES[id]
}
